//      
import React, { Component,           } from 'react';
import { css } from 'styled-components';

import { mergeClassNames } from 'utils/functions';

                    
                                              
                 
                      
                  
                            
                     
                                          
                      
                                                      
                           
                           
                      
                                                  
                   
  

const selectCss = css`
    /* fix for the ugly firefox selects */
    /* https://github.com/twbs/bootstrap/issues/16201 */
    -webkit-appearance: none;
    -moz-appearance: none !important;
    appearance: none;
    background: transparent
        url('data:image/gif;base64,R0lGODlhBgAGAKEDAFVVVX9/f9TU1CgmNyH5BAEKAAMALAAAAAAGAAYAAAIODA4hCDKWxlhNvmCnGwUAOw==')
        right center no-repeat !important;
    background-position: calc(100% - 5px) center !important;
`;

export class Select extends Component              {
    static defaultProps = {
        label: '',
        helpText: '',
        className: '',
        errorText: '',
        labelClassName: '',
    };

    render() {
        let {
            css = '',
            name,
            label,
            helpText,
            className,
            labelClassName,
            errorText,
            children,
            ...domProps
        } = this.props;
        const errorClass = errorText ? 'is-invalid' : '';
        className = mergeClassNames('form-control', className, errorClass);
        labelClassName = mergeClassNames('form-label', labelClassName);

        return (
            <div className='form-group' css={css}>
                {label && (
                    <label className={labelClassName} htmlFor={`id_${name}`}>
                        {label}
                    </label>
                )}
                <select
                    name={`id_${name}`}
                    id={`id_${name}`}
                    className={className}
                    css={selectCss}
                    {...domProps}
                >
                    {children}
                </select>
                {errorText && (
                    <small className='form-text text-danger'>{errorText}</small>
                )}
                {helpText && <small className='form-text text-muted'>{helpText}</small>}
            </div>
        );
    }
}

export default Select;
